import { render, staticRenderFns } from "./foodCate.vue?vue&type=template&id=fe37b792&scoped=true&"
import script from "./foodCate.vue?vue&type=script&lang=js&"
export * from "./foodCate.vue?vue&type=script&lang=js&"
import style0 from "./foodCate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe37b792",
  null
  
)

export default component.exports